<template>
  <div class="col-span-12 mt-3 flex justify-between">
    <BaseButton
      color="primary"
      :is-outline="true"
      icon="funnel-dollar"
      @click="this.showForm = !this.showForm"
      :tooltip="$t('global.filters')"
      :title="null"
    />
    <BaseDeleteButton
      :tooltip="$t('button.remove')"
      @click="handleClickRemove"
    />
  </div>
  <div class="formandresult flex">
    <StatsBlockForm
      v-if="showForm"
      :index="index"
      :block_form="block.form"
      @updateFormField="handleUpdateValues"
      @closeForm="showForm = false"
    />
    <div class="mt-12 w-1/2 px-6" v-if="block?.data?.no_data">
      <div
        class="flex content-center border-l-4 border-yellow-400 bg-yellow-50 p-4"
      >
        <div class="flex">
          <div class="flex-shrink-0">
            <font-awesome-icon
              :icon="['fal', 'exclamation-triangle']"
              size="2x"
              class="text-yellow-700"
              color="warning"
            />
          </div>
          <div class="ml-3 h-full">
            <h1 class="text-yellow-400">
              {{ $t('validation.no_data_in_stats') }}
            </h1>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-12 w-1/2 px-6" v-if="block?.data?.no_display">
      <div
        class="flex content-center border-l-4 border-yellow-400 bg-yellow-50 p-4"
      >
        <div class="flex">
          <div class="flex-shrink-0">
            <font-awesome-icon
              :icon="['fal', 'exclamation-triangle']"
              size="2x"
              class="text-yellow-700"
              color="warning"
            />
          </div>
          <div class="ml-3 h-full">
            <h1 class="text-yellow-400">
              {{ $t('validation.no_display_selected_in_stats') }}
            </h1>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-12 w-1/2 px-6" v-if="block?.data?.development">
      <div
        class="bg-danger-100 flex content-center border-l-4 border-yellow-400 p-4"
      >
        <div class="flex">
          <div class="flex-shrink-0">
            <font-awesome-icon
              :icon="['fal', 'exclamation-triangle']"
              size="2x"
              class="text-danger-700"
              color="danger"
            />
          </div>
          <div class="ml-3 h-full">
            <h1 class="text-danger-500">Development in progress.....</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="w-1/2" v-if="block?.data?.table || block?.data?.chart">
      <div class="m-2 mt-4 flex justify-end p-9">
        <BaseDropDownMenu
          title="Actions"
          size="small"
          :options="[
            {
              label: 'Export excel',
              icon: 'file-excel',
              gate: true,
              action: handelClickExport
            }
          ]"
        />
      </div>
      <div class="border-dark m-2 mt-4 border p-9" v-if="block?.data?.table">
        <BaseContentTable
          :columns="block.data?.table?.metadata?.columns"
          :modelList="block.data?.table?.data"
        />
      </div>
      <div class="border-dark m-2 mt-4 border p-9" v-if="block?.data?.chart">
        <Bar
          v-if="['CRE_PER'].includes(block?.form?.type)"
          :options="chartOptions"
          :data="block?.data?.chart"
          :chart-id="chartId"
          :dataset-id-key="datasetIdKey"
          :plugins="plugins"
          :css-classes="cssClasses"
          :styles="styles"
          :width="width"
          :height="height"
        />
        <Pie
          v-else
          :options="chartOptions"
          :data="block?.data?.chart"
          :chart-id="chartId"
          :dataset-id-key="datasetIdKey"
          :plugins="plugins"
          :css-classes="cssClasses"
          :styles="styles"
          :width="width"
          :height="height"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import StatsBlockForm from '@p/stats/components/StatsBlockForm'
import { Pie, Bar } from 'vue-chartjs'
import {
  Chart,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
  LinearScale,
  CategoryScale
} from 'chart.js'

Chart.register(
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  BarElement,
  LinearScale,
  BarElement,
  CategoryScale,
  LinearScale
)

export default {
  name: 'StatsBlockComponent',
  components: { StatsBlockForm, Pie, Bar },
  data() {
    return {
      showForm: true,
      chartData: {
        labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
        datasets: [
          {
            // backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
            data: [40, 20, 80, 10]
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  props: {
    index: {},
    block: {},
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {
        return {}
      }
    },
    plugins: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters({ statsBlock: 'stats/getStatsBlock' })
  },
  methods: {
    ...mapMutations({ processUpdateFormMutation: 'stats/updateFormAttribute' }),
    ...mapActions({
      processExportStatsBlockDataToExcel: 'stats/exportStatsBlockDataToExcel'
    }),
    handleClickRemove() {
      // console.log('in child')
      this.$emit('clickRemove', this.index)
    },
    handelClickExport() {
      this.processExportStatsBlockDataToExcel({
        ...this.statsBlock[this.index].form,
        action: 'export',
        index: this.index
      })
    },
    handleUpdateValues(values) {
      this.processUpdateFormMutation(values)
    }
  },
  mounted() {
    console.log('block?.data?.chart', this.block?.data?.chart)
  }
}
</script>
